import { createSelector } from '@ngrx/store';

import { AnalyticsSessionStateKey, selectGlobalAppState } from '../../app-global-keys';

import { initialAnalyticsSessionState } from './analytics-session.model';

export const selectAnalyticsSessionState = createSelector(selectGlobalAppState, globalState =>
  globalState ? globalState[AnalyticsSessionStateKey] : initialAnalyticsSessionState
);

export namespace AnalyticsSessionSelectors {
  export const rumSessionId = createSelector(selectAnalyticsSessionState, state => state.rumSessionId);
  export const fullStorySessionUrl = createSelector(selectAnalyticsSessionState, state => state.fullStorySessionUrl);

  /**
   * Both recorders' sessions together, so the cross-link reads one stream. Memoized, so it re-emits
   * only when one of them actually changes.
   */
  export const linkableSessions = createSelector(
    rumSessionId,
    fullStorySessionUrl,
    (rumSessionId, fullStorySessionUrl) => ({ rumSessionId, fullStorySessionUrl })
  );
}
